import produce from 'immer';
import { CREATE_INTEGRATION_REQUEST, CREATE_INTEGRATION_SUCCESS, CREATE_INTEGRATION_FAILURE, LOAD_INTEGRATION_REQUEST, LOAD_INTEGRATION_SUCCESS, LOAD_INTEGRATION_FAILURE, UPDATE_INTEGRATION_REQUEST, UPDATE_INTEGRATION_SUCCESS, UPDATE_INTEGRATION_FAILURE, } from './constants';
export var initialState = {
    integration: {},
    integrationNew: null,
    loading: false,
    error: false,
};
function integrationNewReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case CREATE_INTEGRATION_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case CREATE_INTEGRATION_SUCCESS:
                state.integrationNew = action.integration;
                state.loading = false;
                state.error = false;
                break;
            case CREATE_INTEGRATION_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            case UPDATE_INTEGRATION_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case UPDATE_INTEGRATION_SUCCESS:
                state.integrationNew = action.integration;
                state.loading = false;
                state.error = false;
                break;
            case UPDATE_INTEGRATION_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            case LOAD_INTEGRATION_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case LOAD_INTEGRATION_SUCCESS:
                state.integration = action.integration;
                state.loading = false;
                state.error = false;
                break;
            case LOAD_INTEGRATION_FAILURE:
                state.loading = false;
                state.error = true;
                break;
            default:
                break;
        }
    });
}
export default integrationNewReducer;
